import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
// ====== 优化：ECharts 改为懒加载 ======
// 原来：import * as echarts from 'echarts'; （~1MB 进入主包）
// 现在：使用动态 import()，只在首次使用 <div echarts> 指令时才下载
import { ApiModule } from 'ng-upgrade-api';
import { XskBasisModule } from 'ng-upgrade-basis';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
// import { NgxAmapModule } from 'ngx-amap';
import { NgxEchartsModule } from 'ngx-echarts';
import { MomentModule } from 'ngx-moment';
import { AppRoutingModule } from './app-routing.module';
import { GesturePassModule } from './modals/gesture-pass/gesture-pass.module';
import { GreetBookModule } from './modals/greet-book/greet-book.module';
import { LoginModalModule } from './pages/login-modal/login-modal.module';
import { SwitchTerritoryModalModule } from './pages/login/switch-territory-modal/switch-territory-modal.module';

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    XskBasisModule,
    IonicModule.forRoot({
      mode: 'ios',
      backButtonText: ''
    }),
    AppRoutingModule,
    ApiModule,
    // NgxAmapModule.forRoot({
    //   apiKey: 'de82edae47fe09a620b1666ec901d228'
    // }),
    NzSegmentedModule,
    NgxEchartsModule.forRoot({
      // 懒加载 echarts：只在实际渲染图表时才加载 ~1MB 的 echarts 库
      echarts: () => import('echarts')
    }),
    SwitchTerritoryModalModule,
    GesturePassModule,
    MomentModule,
    GreetBookModule,
    LoginModalModule
  ],
  exports: [
    BrowserModule,
    XskBasisModule,
    IonicModule,
    AppRoutingModule,
    ApiModule,
    // NgxAmapModule,
    NzSegmentedModule,
    NgxEchartsModule,
    SwitchTerritoryModalModule,
    GesturePassModule,
    MomentModule,
    GreetBookModule,
    LoginModalModule
  ],
})

export class SharedModule {
}
